module.exports = __webpack_public_path__ + "static/media/datatron.8ba14060.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/datatron.png
// module id = 82
// module chunks = 0